/* eslint-disable no-unused-vars */
import {
  Box, Button, Checkbox, Container, CircularProgress, IconButton,
  LinearProgress,
} from '@mui/material';
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { DeleteOutlineRounded } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import AlertContext from '../../../../Context/AlertContext';
import ConfirmationContext from '../../../../Context/ConfirmationContext';
import {
  getCart, deleteFormCart,
} from '../../../../Redux/Models/market';
import { formatNumToCurrency, isB2C } from '../../../../Utils/helpers';
import { getUserData } from '../../../../Utils/storages';
import Elements from '../../../Elements';

export default function Component({
  classes,
  error,
  message,
  cart,
  isLoading,
  deletedFromCart,
}) {
  const navigate = useNavigate();
  const user = getUserData();
  const dispatch = useDispatch();
  const { openConfirmation, closeConfirmation } = useContext(ConfirmationContext);
  const B2C = isB2C();
  const { t } = useTranslation();

  const { openAlert } = useContext(AlertContext);

  useEffect(() => {
    if (error) {
      if (error === 401) return;
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  useEffect(() => {
    if (!B2C) {
      openConfirmation({
        desc: 'Ops. Sorry this area only for B2C user',
        title: 'Something went wrong',
        confirmText: user.id ? 'Ok, go back' : 'Sign In',
        handleAgree: () => {
          if (!user.id) {
            navigate(`${ROUTES.signin()}`);
          } else {
            navigate(`${ROUTES.market()}`);
          }
          closeConfirmation();
        },
        handleClose: () => {
          navigate(`${ROUTES.market()}`);
          closeConfirmation();
        },
        noCancel: true,
      });
    }
  }, [B2C]);

  useEffect(() => {
    dispatch(getCart(user.id));
  }, []);

  const handleDelete = (id) => {
    openConfirmation({
      title: 'Delete Item from Cart?',
      confirmText: 'Delete',
      handleAgree: () => {
        dispatch(deleteFormCart(user.id, id));
        closeConfirmation();
      },
      handleClose: () => {
        closeConfirmation();
      },
    });
  };

  useEffect(() => {
    if (deletedFromCart) {
      openAlert({
        message: 'Product has been deleted from cart',
        severity: 'success',
      });
    }
  }, [deletedFromCart]);

  return (
    <Elements.PageBase navigate={navigate} noNav>
      <Box className={classes.root}>
        <Elements.Navigator title={t('cart.title')} />

        <Container sx={{ py: 2 }}>
          <Box>

            {isLoading && (
            <Box textAlign="center">
              <LinearProgress color="inherit" />
            </Box>
            )}

            {cart.map((item, index) => (
              <Box display="flex" gap={1.5} mb={2} key={index} alignItems="flex-start">
                <Box display="flex" gap={1.5} flex={1}>
                  <Box position="relative" onClick={() => navigate(`${ROUTES.market()}/search/${item.item?.id}`)}>
                    <img
                      width="80px"
                      height="80px"
                      className="rounded cover"
                      src={item.item?.photo}
                      alt="baco"
                    />
                    <Box position="absolute" bottom="2px" left="2px">
                      <img src={Images.CheckRed} alt="check-icon" />
                    </Box>
                  </Box>
                  <Box flex={1} alignSelf="center">
                    <Box display="flex" justifyContent="space-between" gap={0.5} className="weight-600">
                      <div>{item.item?.name}</div>
                      <Box className="s-10">
                        {t('marketPage.qty')}
                        {' '}
                        1
                      </Box>
                    </Box>
                    <Box display="flex" className="s-10 mute" gap={0.5} flexWrap="wrap" alignItems="center" mt={0.25}>
                      <div>{item.category_name || '-'}</div>
                      <div>
                        ・
                        {item.condition_name || '-'}
                      </div>
                      <div>
                        ・
                        {item.item?.volume || '0 mL'}
                      </div>
                    </Box>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                      <Box className="s-16 weight-700">
                        {formatNumToCurrency(Number(item.item?.price))}
                      </Box>
                      <Box display="flex" gap={0.5} sx={{ cursor: 'pointer' }}>
                        <Box onClick={() => handleDelete(item.id)} className="s-10 weight-600 primary-green">{t('cart.remove')}</Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            ))}
            {!cart.length && !isLoading && 'No item added to cart'}
          </Box>
        </Container>

        <Box position="absolute" bottom={0} left={0} right={0} py={1} px={1.5} bgcolor="white">
          <Button sx={{ display: cart.length ? 'block' : 'none' }} variant="contained" className="btn-contained" fullWidth onClick={() => navigate(ROUTES.purchase())}>
            {t('cart.buy')}
            {' '}
            (
            {cart.length}
            {' '}
            {t('common.items')}
            )
          </Button>
        </Box>
      </Box>
    </Elements.PageBase>
  );
}
